export const CountdownTimer = ({ data }: any) => {
    return (
        <div className="py-8 px-4 text-center bg-red-50">
            <h3 className="text-xl font-bold text-red-600 mb-4">{data.title || "Limited Time Offer!"}</h3>
            <div className="flex justify-center gap-4 text-2xl font-mono font-bold">
                <div className="bg-white p-3 rounded shadow">00</div>:
                <div className="bg-white p-3 rounded shadow">00</div>:
                <div className="bg-white p-3 rounded shadow">00</div>
            </div>
        </div>
    );
};
